/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable camelcase */
import React, { Component } from "react";

import {
  CHeader,
  CSpinner,
  CButton,
  CInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader
} from "@coreui/react";
import { FaExclamationCircle, FaLock } from "react-icons/fa";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Redirect, Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";

import Banner from "./Banner";
import Header from "./Header";
import NotesSidebar from "./NotesSidebar";
import Sidebar from "./Sidebar";
import { logout, firstLoginDone } from "../actions/baseActions";
import { setShowChat } from "../actions/chatActions";
import { setLayout } from "../actions/layoutActions";
import { setObj, showHelpdesk, hideHelpdesk } from "../actions/noteActions";
import { profileUpdate, profileGet } from "../actions/profileActions";
import EmotionsModal from "../components/EmotionsModal";
import FaqChatWidget from "../components/FaqChatWidget";
import AvisoFormulariosPendentes from "../components/Formulario/AvisoFormulariosPendentes";
import HelpdeskModal from "../components/HelpdeskModal";
import Tour from "../components/Tour";
import URL from "../config/api";
import axios from "../config/axios";
import { isRespondenteDeFormularios } from "../config/formularios";
import Template from "../template/template";

import "./styles.css";

// Grupos que NÃO exibem o modal de troca de senha no primeiro acesso.
const GRUPOS_SEM_TROCA_SENHA_PRIMEIRO_ACESSO = [45, 79, 80, 92];

// Teto de espera pela resposta do salvamento. Durante o envio o modal não tem
// X, não fecha no backdrop e o "Pular por agora" fica desabilitado — este
// timeout é a única coisa que devolve o controle ao usuário se o servidor
// pendurar. Vale só para esta chamada; os demais usos do profileUpdate seguem
// sem limite.
const TIMEOUT_PRIMEIRO_ACESSO = 15000;

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      routes: [],
      banner: false,
      emotionCard: null,
      // Se a checagem do card de emoções já terminou (tenha card ou não). O
      // aviso de formulários pendentes espera por ela para não abrir junto.
      emotionChecked: false,
      passwordEdit: false,
      password: "",
      confirmPassword: "",
      parents: [],
      user: {},
      salvando: false,
      firstLogin: props.user.first_login
    };
  }

  Loading = () => (
    <div className="d-flex w-100 justify-content-center">
      <CSpinner color="secondary" size="sm" />
    </div>
  );

  UNSAFE_componentWillMount() {
    try {
      // Todas as rotas vêm do cadastro do backend (configuration_links); quem
      // pode abrir cada uma é o access_roles_links, conferido pelo ProtectedRoute.
      let routes = this.props.general.routes
        .map(menu => {
          try {
            let component = Loadable({
              loader: () => import(`../pages/${menu.local}`),
              loading: this.Loading
            });

            const { defaultProps } = require(`../pages/${menu.local}`).default
              .WrappedComponent;

            return {
              path: menu.path,
              name: menu.name,
              component,
              exact: menu.exact,
              id: menu.id,
              hideLayout: defaultProps?.hideLayout || false,
              hideContainer: defaultProps?.hideContainer || false
            };
          } catch (err) {
            return {
              path: "./Dashboard",
              name: menu.name,
              component: <Redirect to="/" />,
              exact: menu.exact,
              id: menu.id,
              hideLayout: false,
              hideContainer: false
            };
          }
        })
        .filter(route => route.hideLayout === false);

      this.setState({ routes });

      const roleId = this.props.user.user_roles[0].role_id;
      const groupId = this.props.general.active_roles.group_id;
      const podeTrocarSenha =
        roleId !== 7 &&
        roleId !== 9 &&
        !GRUPOS_SEM_TROCA_SENHA_PRIMEIRO_ACESSO.includes(groupId);

      this.setState({
        passwordEdit: Boolean(this.state.firstLogin) && podeTrocarSenha
      });
    } catch (err) {
      this.props.logout();
    }
  }

  // Campos editáveis do modal de primeiro acesso (nome, e-mail, telefone).
  // Todos ficam na raiz do registro do usuário, como no Profile.
  campoUsuarioHandler(campo, valor) {
    this.setState(prevState => ({
      user: { ...prevState.user, [campo]: valor }
    }));
  }

  // Fecha o modal de primeiro acesso e conclui o first_login. Idempotente de
  // propósito: o callback do POST pode chegar com o modal já fechado, e uma
  // implementação em toggle reabriria a tela nesse caso.
  fecharPrimeiroAcesso() {
    if (!this.state.passwordEdit) return;

    this.setState({ passwordEdit: false, firstLogin: false }, () => {
      this.props.firstLoginDone();
    });
  }

  salvarPrimeiroAcesso() {
    const { user, password, confirmPassword, salvando } = this.state;

    if (salvando) return;

    // O perfil é carregado de forma assíncrona no componentDidMount; sem o id
    // o update iria para .../update/undefined e falharia em silêncio.
    if (!user?.id) {
      toastr.info("Aguarde", "Ainda estamos carregando os seus dados");
      return;
    }

    if (!user.name?.trim()) {
      toastr.error("Informe o seu nome", "O campo não pode ficar em branco");
      return;
    }

    if (user.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email.trim())) {
      toastr.error("E-mail inválido", "Verifique o endereço informado");
      return;
    }

    // A senha é opcional: em branco, mantém a atual.
    if (password || confirmPassword) {
      if (password.length < 8) {
        toastr.error(
          "A senha precisa de pelo menos 8 caracteres",
          "Digite novamente"
        );
        return;
      }

      if (password !== confirmPassword) {
        toastr.error("As senhas não são iguais", "Digite novamente");
        return;
      }
    }

    this.setState({ salvando: true });

    this.props.profileUpdate(
      // Só envia password quando o usuário de fato digitou uma nova senha.
      password ? { ...user, password } : user,
      this.state.user_complement,
      () => {
        this.setState({ salvando: false });
        toastr.success("Sucesso", "Dados atualizados com sucesso!");
        this.fecharPrimeiroAcesso();
      },
      this.state.parents.map(parent => parent.id),
      {
        timeout: TIMEOUT_PRIMEIRO_ACESSO,
        onError: motivo => {
          // O modal segue aberto com o que foi digitado, para nova tentativa.
          this.setState({ salvando: false });
          toastr.error(
            "Não foi possível salvar",
            motivo || "Verifique sua conexão e tente novamente"
          );
        }
      }
    );
  }

  componentDidMount() {
    const get = this.props.user.user.id;
    this.props.setObj(20, get, this.props.currentRoute);

    this.props.profileGet(get, this.props.user.token, user => {
      this.setState(() => ({
        user: user.user,
        user_complement: user.user_complement,
        parents: user.user_parent.map(user => user.parent)
      }));
    });
    let groupId = this.props.general.active_roles.group_id;
    this.props.setLayout(true);

    if (this.state.routes.length > 0) {
      this.setState({
        loading: false
      });
    }

    const emocoesConferidas = () => this.setState({ emotionChecked: true });

    if (groupId !== null && this.props.user.user_roles[0]?.role_id === 7) {
      if (this.props?.user.emotions === false) {
        this.setState({ emotionCard: false }, emocoesConferidas);
      } else {
        axios
          .get(`${URL.api}access/group/singleView/${groupId}`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(respgroup => {
            if (respgroup?.data?.data?.group.emotion_card) {
              axios
                .get(`${URL.api}access/user_emotion/today`, {
                  headers: { authorization: `Bearer ${this.props.user.token}` }
                })
                .then(resptoday => {
                  this.setState(
                    { emotionCard: resptoday.data.data === null },
                    emocoesConferidas
                  );
                })
                .catch(emocoesConferidas);
            } else {
              emocoesConferidas();
            }
          })
          .catch(emocoesConferidas);
      }
    } else {
      emocoesConferidas();
    }

    window.banner = () => this.setState({ banner: true });

    // ----------------- SOCKET MARVIN INÍCIO -------------------
    /* let data = {
      //id: this.props.user.user.id,
      //name: this.props.user.user.username
      id: 7,
      name: 'Nome Usuário'
    }

    const { endpoint } = this.state;
    const socket = socketIOClient(endpoint);

    this.setState({
      socket
    }, () => {
      // --------------------- AVISA AO SERVER QUE CONECTOU -------------
      this.state.socket.emit('userConected', data);

      // --------------------- ENVIA OBJ PARA O USUÁRIO 7 NA 'PORTA' notification -------------
      let obj = {
        user_id: 7,
        type: 'notification',
        message: {
          title: 'Título notificação',
          message: 'Mensagem notificação'
        },
        sendTo: [7]
      }
      this.state.socket.emit('socket', obj);
    })

    // --------------------- RECEVE DATA NA 'PORTA' notification -------------
    socket.on("notification", data => {
    }); */
    // ----------------- SOCKET MARVIN FIM -------------------
  }

  // Dados exibidos no modal de primeiro acesso. Todos vêm do redux no momento
  // do login, então não dependem do profileGet assíncrono do componentDidMount.
  dadosPrimeiroAcesso() {
    const { name, username } = this.props.user.user;
    const { role_name, school_name, group_name } =
      this.props.general.active_roles;

    const partes = (name || "").trim().split(/\s+/).filter(Boolean);
    const ultimo = partes.length > 1 ? partes[partes.length - 1][0] : "";

    return {
      username,
      primeiroNome: partes[0] || "",
      // Iniciais do primeiro e do último nome, para o avatar.
      iniciais: partes.length ? `${partes[0][0]}${ultimo}`.toUpperCase() : "",
      // school_name pode vir nulo para perfis que atuam na rede inteira;
      // nesse caso o grupo é a referência de lotação.
      lotacao: [role_name, school_name || group_name]
        .filter(Boolean)
        .join(" · ")
    };
  }

  render() {
    const { banner } = this.state;
    const { primeiroNome, iniciais, username, lotacao } =
      this.dadosPrimeiroAcesso();
    // Os campos editáveis só existem depois que o profileGet responde.
    const perfilCarregado = Boolean(this.state.user?.id);
    const { salvando } = this.state;
    const camposBloqueados = !perfilCarregado || salvando;
    let isAlagoasStudent =
      (this.props.general.active_roles.group_id === 49 ||
        this.props.general.active_roles.group_id === 86) &&
      this.props.general.active_roles.role_id === 7;

    return (
      <div className={`app${banner ? " banner" : ""}`}>
        {this.props.note?.showHelpdesk && (
          <HelpdeskModal
            show={this.props.note.showHelpdesk}
            base64image={this.props.note.base64image}
            onClose={() => this.props.hideHelpdesk()}
          />
        )}
        {this.props.chat?.showChat && (
          <FaqChatWidget onClose={() => this.props.setShowChat(false)} />
        )}
        {banner && <Banner onClick={() => this.setState({ banner: false })} />}
        {!this.state.loading && (
          <React.Fragment>
            <Template />
            <div className="c-app c-default-layout">
              {/* Acima do <Switch>: a jornada do tour atravessa quatro telas, e
                  dentro de uma página ele seria desmontado na primeira
                  navegação. Só roda quando o professor pede (ícone no header) —
                  não há gatilho automático nem estado persistido. */}
              <Tour />
              <Sidebar />
              <NotesSidebar />
              <div className="c-wrapper">
                <CHeader
                  style={{
                    height: "60px",
                    flexWrap: "nowrap",
                    overflowWrap: "anywhere"
                  }}
                >
                  <Header />
                </CHeader>
                <div className="c-body">
                  <main className="c-main p-0">
                    <Switch>
                      {this.state.routes.map((route, idx) => (
                        <Route
                          key={idx}
                          path={route.path}
                          exact={route.exact}
                          name={route.name}
                          render={props => (
                            <div
                              className={
                                route.hideContainer
                                  ? "d-flex flex-column"
                                  : "container-fluid d-flex flex-column pt-4"
                              }
                              style={{
                                minHeight: "100%",
                                padding: route.hideContainer ? "0" : "0 5%"
                              }}
                            >
                              <route.component
                                currentRoute={route.id}
                                {...props}
                              />
                            </div>
                          )}
                        />
                      ))}
                      <Redirect from="/" to="/dashboard" />
                    </Switch>
                  </main>
                  {isAlagoasStudent && (
                    <footer>
                      <div className="helper-layout-modal">
                        <FaExclamationCircle
                          size={40}
                          color="#02517D"
                          onClick={() => this.props.history.push(`/requests`)}
                        />
                      </div>
                    </footer>
                  )}
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
        {this.state.emotionCard === true &&
          this.state.passwordEdit === false && (
            <EmotionsModal
              onClose={() => this.setState({ emotionCard: false })}
            />
          )}
        {/* Depois do primeiro acesso e do card de emoções: um modal por vez. */}
        {!this.state.loading &&
          this.state.passwordEdit === false &&
          this.state.emotionChecked &&
          this.state.emotionCard !== true &&
          isRespondenteDeFormularios(
            this.props.general.active_roles.role_id
          ) && (
            <AvisoFormulariosPendentes
              token={this.props.user.token}
              history={this.props.history}
            />
          )}
        <CModal
          show={this.state.passwordEdit}
          onClose={() => this.fecharPrimeiroAcesso()}
          centered
          scrollable
          size="lg"
          closeOnBackdrop={false}
          className="first-access-modal"
        >
          <CModalHeader closeButton={false} className="first-access-hero">
            {iniciais && (
              <div className="first-access-avatar bg-primary text-white">
                {iniciais}
              </div>
            )}
            <div className="first-access-identity">
              <h4>
                {primeiroNome
                  ? `Bem-vindo(a), ${primeiroNome}!`
                  : "Bem-vindo(a)!"}
              </h4>
              {lotacao && <span>{lotacao}</span>}
              {username && <span>Login: {username}</span>}
            </div>
          </CModalHeader>
          <CModalBody className="first-access-content">
            <div className="first-access-notice">
              <FaLock className="first-access-notice-icon text-primary" />
              <div>
                <strong>Este é o seu primeiro acesso</strong>
                <p>
                  Confira os seus dados e, se quiser, cadastre uma nova senha.
                  Deixando os campos de senha em branco, a atual é mantida.
                </p>
              </div>
            </div>

            <form autoComplete="off">
              <h6 className="first-access-section">
                Seus dados
                {!perfilCarregado && (
                  <span className="first-access-loading">
                    <CSpinner color="secondary" size="sm" /> carregando…
                  </span>
                )}
              </h6>

              <div className="first-access-field">
                <label className="first-access-label" htmlFor="first-name">
                  Nome completo
                </label>
                <CInput
                  id="first-name"
                  type="text"
                  placeholder="Digite o seu nome completo"
                  disabled={camposBloqueados}
                  value={this.state.user.name || ""}
                  onChange={e =>
                    this.campoUsuarioHandler("name", e.target.value)
                  }
                />
              </div>

              <div className="form-row">
                <div className="col-md-6 first-access-field">
                  <label className="first-access-label" htmlFor="first-email">
                    E-mail
                  </label>
                  <CInput
                    id="first-email"
                    type="email"
                    placeholder="nome@exemplo.com"
                    disabled={camposBloqueados}
                    value={this.state.user.email || ""}
                    onChange={e =>
                      this.campoUsuarioHandler("email", e.target.value)
                    }
                  />
                </div>
                <div className="col-md-6 first-access-field">
                  <label className="first-access-label" htmlFor="first-phone">
                    Telefone
                  </label>
                  <CInput
                    id="first-phone"
                    type="tel"
                    placeholder="(00) 00000-0000"
                    disabled={camposBloqueados}
                    value={this.state.user.phone || ""}
                    onChange={e =>
                      this.campoUsuarioHandler("phone", e.target.value)
                    }
                  />
                </div>
              </div>

              <h6 className="first-access-section">Senha</h6>

              <div className="form-row">
                <div className="col-md-6 first-access-field">
                  <label
                    className="first-access-label"
                    htmlFor="first-password"
                  >
                    Nova senha
                  </label>
                  <CInput
                    id="first-password"
                    type="password"
                    autoComplete="new-password"
                    placeholder="Digite uma nova senha"
                    disabled={salvando}
                    value={this.state.password}
                    onChange={e => this.setState({ password: e.target.value })}
                  />
                </div>
                <div className="col-md-6 first-access-field">
                  <label
                    className="first-access-label"
                    htmlFor="first-password-confirm"
                  >
                    Confirme a nova senha
                  </label>
                  <CInput
                    id="first-password-confirm"
                    type="password"
                    autoComplete="new-password"
                    placeholder="Digite sua nova senha novamente"
                    disabled={salvando}
                    value={this.state.confirmPassword}
                    onChange={e =>
                      this.setState({ confirmPassword: e.target.value })
                    }
                  />
                </div>
              </div>

              <small className="first-access-hint">
                Use no mínimo 8 caracteres.
              </small>
            </form>
          </CModalBody>
          <CModalFooter className="first-access-footer">
            <CButton
              color="secondary"
              disabled={salvando}
              onClick={() => this.fecharPrimeiroAcesso()}
            >
              Pular por agora
            </CButton>
            <CButton
              color="primary"
              disabled={camposBloqueados}
              onClick={() => this.salvarPrimeiroAcesso()}
            >
              {salvando ? (
                <>
                  <CSpinner size="sm" className="mr-2" />
                  Salvando…
                </>
              ) : (
                "Salvar e continuar"
              )}
            </CButton>
          </CModalFooter>
        </CModal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  layout: state.layout,
  note: state.note,
  chat: state.chat
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setLayout,
      logout,
      showHelpdesk,
      hideHelpdesk,
      profileUpdate,
      profileGet,
      setObj,
      firstLoginDone,
      setShowChat
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);
